export const FETCH_ALLFEES_REQUEST = 'FETCH_ALLFEES_REQUEST'
export const FETCH_ALLFEES_SUCCESS = 'FETCH_ALLFEES_SUCCESS'
export const FETCH_ALLFEES_FALIURE = 'FETCH_ALLFEES_FALIURE'
